import { isNotNullish } from '@chainflip/utils/guard';
import { getAllBoostPoolBalancesForAccount } from '@/shared/graphql/cache/boost';
import { useGqlQuery } from '@/shared/hooks/useGqlQuery';

export type BoostBalancesProps = {
  account?: string | null;
  enabled?: boolean;
};

export default function useBoostBalances({ account, enabled = true }: BoostBalancesProps) {
  return useGqlQuery(getAllBoostPoolBalancesForAccount, {
    variables: { accountId: account as string },
    context: { clientName: 'statechainCache' },
    refetchInterval: 5_000,
    enabled: isNotNullish(account) && enabled,
    select: (queryResult) => queryResult.balances?.nodes ?? [],
  });
}
